<div class="customer-account-page my-4">
  <div class="container-md">
    <div class="d-flex flex-column flex-sm-row align-items-center mb-3">
      <div class="user-image me-sm-3 mb-2 mb-sm-0 d-flex align-items-center justify-content-center">
        <i-feather name="user"
                   class="user-image-placeholder"></i-feather>
      </div>
      <div class="text-center text-sm-start w-100 text-truncate">
        <h1 class="h4 mb-0">{{'CUSTOMER-ACCOUNT.PAGE-TITLE' | translate}}</h1>
        <span class="text-secondary">{{userName}}</span>
      </div>
    </div>

    <app-customer-account-navigation>
    </app-customer-account-navigation>

    <router-outlet>
    </router-outlet>
  </div>
</div>
